export default "__VITE_ASSET__d4RWu1p0__"